import LazyLoad from './lazyLoad';
const $ = jQuery.noConflict();
import Popup from './popup';
import Sliders from './sliders';

'use strict';
const LoadMoreProducts = {
	$wrapper: $('.js-post-wrap'),
	page: 1,
	div: $('.products-block__wrap-boxes'),

	catId: 0,

	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		const _this = this;

		$('#products-block__wrap-select').on('change', function() {
			LoadMoreProducts.catId = $('#products-block__wrap-select :selected').attr('data-cat');
		});

		$('.js-load-more').unbind().click(function() {
			$('.products-block__wrap-boxes-loader').addClass('is-visible');

			const taxonomyCatIds = document.querySelectorAll('.js-products-block__wrap-select');
			let supplementType;
			let mainBenefit;
			let feature;
			let age;
			for (let i = 0; i < taxonomyCatIds.length; i++) {
				const dataName = taxonomyCatIds[i].getAttribute('data-name');
				const value = taxonomyCatIds[i].options[taxonomyCatIds[i].selectedIndex].value;
				if(dataName === 'supplement-type' && value !== undefined) {
					supplementType = value;
				}
				if(dataName === 'feature' && value !== undefined) {
					feature = value;
				}
				if(dataName === 'main-benefit' && value !== undefined) {
					mainBenefit = value;
				}
				if(dataName === 'age' && value !== undefined) {
					age = value;
				}
			}
			const obj = {
				supplementType,
				feature,
				mainBenefit,
				age
			};
			// if is taxonomy page
			if ($('body.category').length > 0) {
				$.ajax({
					type: 'POST',
					// eslint-disable-next-line no-undef
					url: fwsLocalized.ajaxUrl,
					data: {
						action: 'LoadMoreFilterProducts',
						page: _this.page + 1,
						catIds: obj,
					},
					success: function(response) {
						$('.products-block__wrap-boxes-loader').removeClass('is-visible');
						$(response.htmlResources).appendTo($('.js-post-wrap'));
						_this.page++;
						if (parseInt(_this.page) === parseInt(response.max)) {
							$('.js-load-more').addClass('hidden');
						}
						LazyLoad.init();
						Popup.init();
						Sliders.init();
					}
				});
			} else {
				$.ajax({
					type: 'POST',
					// eslint-disable-next-line no-undef
					url: fwsLocalized.ajaxUrl,
					data: {
						action: 'LoadMoreProducts',
						page: _this.page + 1,
						catId: LoadMoreProducts.catId,
					},
					success: function(response) {
						$('.products-block__wrap-boxes-loader').removeClass('is-visible');
						$(response.htmlPosts).appendTo($('.js-post-wrap'));
						_this.page++;
						if (parseInt(_this.page) === parseInt(response.max)) {
							$('.js-load-more').addClass('hidden');
						}
						LazyLoad.init();
						Popup.init();
						Sliders.init();
					}
				});
			}
		});
	},
};

export default LoadMoreProducts;
